import { createSlice } from '@reduxjs/toolkit';

import SpecialCashbackRateRepository from '../../repositories/Admin/FastCash/SpecialCashbackRateRepository';
import { createRestSlice } from '../../utils/RestSlice';

const specialCashbackRatesRestSlice = createRestSlice({
  resource: 'specialCashbackRates',
  repository: SpecialCashbackRateRepository,
  slices: ['loadSpecialCashbackRates'],
});

const initialState = {
  ...specialCashbackRatesRestSlice.initialState,
};

const specialCashbackRatesSlice = createSlice({
  name: 'specialCashbackRates',
  initialState,
  reducers: {
    ...specialCashbackRatesRestSlice.reducers,
  },
});

export default specialCashbackRatesSlice.reducer;

export const specialCashbackRatesRestHooks =
  specialCashbackRatesRestSlice.hooks(specialCashbackRatesSlice, [
    'admin',
    'SpecialCashbackRatesSlice',
  ]);
